
seedWebApp.controller('DBUpdaterController', ['$scope', '$rootScope', '$filter', '$window', 'DBUpdaterService', function ($scope, $rootScope, $filter, $window, DBUpdaterService) {

    $rootScope.moduleName = 'Ajustes / DB Updater';
    $scope.filterString = 'Modified';
    $scope.updateCount = 0;
    $scope.Data = [];

    $scope.executeService = function (actionId) {
        $scope.updateCount = 0;
        $scope.alerts = [];

        angular.forEach($scope.Data, function (item) {
            item.ExecuteResult = 'Executing';
        });

        $scope.errorDescription = null;
        $scope.items = DBUpdaterService.execute({ id: actionId }, function (data) {
            $scope.executing = false;
            $scope.loading = false;
            $scope.Data = data;
            $scope.RecalcUpdateCount();
        }, function errorFunc(error) {
            $scope.errorDescription = error;
            $scope.loading = false;
            $scope.executing = false;
        });
    };

    $scope.RecalcUpdateCount = function () {
        $scope.updateCount = 0;
        angular.forEach($scope.Data, function (item) {
            if (item.CheckModified == 'Modified' && item.ExecuteResult != 'Ok') {
                $scope.updateCount++;
            }
        });       
    }

    $scope.verifyTables = function () {
        $scope.loading = true;
        $scope.filterString = 'Modified';
        $scope.executeService('Verify');
    };


    $scope.verifyTables();

    $scope.executeUpdate = function () {
        $scope.executing = true;
        $scope.filterString = 'Modified';
        $scope.executeService('Execute');
    };

    $scope.goBack = function () {
        $window.history.back();
    };

}]);

